import React from "react";
import { useAuthContext } from "@/contexts/auth";
import PleaseSignInPage from "@/components/pleaseSignInPage/PleaseSignInPage";
import Loader from "@/shared/components/Loader/Loader";

export const withLogin = (Page) => {
  return (props) => {
    const { isLogin, loading } = useAuthContext();

    if (loading) {
      return <Loader align="flex-center" isPositionAbsolute />;
    }

    return isLogin
      ? <Page {...props}/>
      : <PleaseSignInPage />;
  };
};
